import { render, staticRenderFns } from "./HistoriqueDpa.vue?vue&type=template&id=2997572c"
import script from "./HistoriqueDpa.vue?vue&type=script&lang=ts"
export * from "./HistoriqueDpa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports